import React from 'react';
import { CheckCircleIcon, ClockIcon, UploadIcon, CircleIcon } from 'lucide-react';
import { DocumentStatus } from '../types/loan.types';
interface DocumentStatusBadgeProps {
  status: DocumentStatus;
  compact?: boolean;
}
const statusConfig: Record<DocumentStatus, {
  label: string;
  bgColor: string;
  textColor: string;
  icon: React.ElementType;
  borderColor: string;
}> = {
  missing: {
    label: 'Missing',
    bgColor: 'bg-red-100',
    textColor: 'text-red-700',
    icon: CircleIcon,
    borderColor: 'border-red-200'
  },
  uploaded: {
    label: 'Uploaded',
    bgColor: 'bg-blue-100',
    textColor: 'text-blue-700',
    icon: UploadIcon,
    borderColor: 'border-blue-200'
  },
  pending_review: {
    label: 'Pending Review',
    bgColor: 'bg-amber-100',
    textColor: 'text-amber-700',
    icon: ClockIcon,
    borderColor: 'border-amber-200'
  },
  approved: {
    label: 'Approved',
    bgColor: 'bg-emerald-100',
    textColor: 'text-emerald-700',
    icon: CheckCircleIcon,
    borderColor: 'border-emerald-200'
  }
};
export function DocumentStatusBadge({
  status,
  compact = false
}: DocumentStatusBadgeProps) {
  const config = statusConfig[status];
  const Icon = config.icon;
  if (compact) {
    return <span className={`inline-flex items-center justify-center w-6 h-6 rounded-full ${config.bgColor} border-2 ${config.borderColor}`} title={config.label} aria-label={config.label} data-id="element-55">
        <Icon className={`w-3.5 h-3.5 ${config.textColor}`} data-id="element-56" />
      </span>;
  }
  return <span className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-lg text-sm font-semibold ${config.bgColor} ${config.textColor} border-2 ${config.borderColor} shadow-sm`} role="status" aria-label={`Document status: ${config.label}`} data-id="element-57">
      <Icon className="w-4 h-4" aria-hidden="true" data-id="element-58" />
      {config.label}
    </span>;
}